import React from "react";

const BannerSection = () => {
  return (
    <>
      <section
        className="hero-section rel z-1 bg-dark-blue pt-25 rpt-5"
        id="home"
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 col-md-10 col-sm-11">
              <div className="hero-content text-white mt-250 mb-215">
                <span className="sub-title wow fadeInUp delay-0-2s">
                  AI-Powered Design to Code
                </span>
                <h1 className="wow fadeInUp delay-0-4s">
                  Transform UI/UX Designs into Production-Ready Code Instantly
                </h1>
                <p className="wow fadeInUp delay-0-6s">
                  Upload your design files and generate clean, responsive HTML & CSS in seconds. Our cutting-edge AI supports Tailwind, Bootstrap, and custom CSS frameworks to accelerate your development workflow.
                </p>
                <div className="hero-btn mt-35 wow fadeInUp delay-0-8s">
                  <a href="#" className="theme-btn style-two">
                    Convert Your Design Now{" "}
                    <i className="fas fa-long-arrow-alt-right" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="hero-right-image wow fadeInLeft delay-0-2s"
          data-wow-duration="2s"
        >
          <img src="https://attherate.dev/host-image/uploads/1760377956_bg-banner.png" alt="Hero" />
        </div>
        <div className="hero-right-circles wow customSlideInRight" />
        <div className="hero-dot-one" />
        <div className="hero-dot-two" />
        <div className="hero-dot-three" />
      </section>
    </>
  );
};

export default BannerSection;